<div class="icon">
  <app-icon [icon]="icon" *ngIf="!busy; else spinner"></app-icon>

  <ng-template #spinner>
    <img src="/assets/spinner.svg" />
  </ng-template>
</div>

<div class="label"><ng-content></ng-content></div>
